import { AlertTriangle } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { PimLink } from '@/features/shared/pim-link';

type LotSizingFillRateMissingVolumesProps = {
  missingProductVolumes: Array<string | number>;
};

export function LotSizingFillRateMissingVolumes({
  missingProductVolumes,
}: LotSizingFillRateMissingVolumesProps) {
  const { t } = useTranslation('lotSizing');

  return (
    <div className='flex flex-1 flex-col items-center gap-3 rounded-lg border border-amber-400 bg-amber-50 px-4 py-4 text-center dark:border-amber-400 dark:bg-amber-950/40'>
      <AlertTriangle className='size-12 shrink-0 text-amber-600 dark:text-amber-400' />
      <div className='flex flex-col gap-1 text-amber-600 text-sm dark:text-amber-300'>
        <p>{t('missingProductVolumesMessage')}</p>
        <span>
          {t('missingProductVolumesPimHint')} <br />
          <span className='flex flex-wrap justify-center gap-x-1'>
            {missingProductVolumes.map((productId, index) => (
              <span className='whitespace-nowrap' key={productId}>
                <PimLink
                  className='font-semibold text-black text-sm italic underline dark:text-white'
                  href={`/products/${productId}/packaging`}
                  withIcon={false}
                >
                  {productId}
                </PimLink>
                {index < missingProductVolumes.length - 1 && ', '}
              </span>
            ))}
          </span>
        </span>
      </div>
    </div>
  );
}
